import React from 'react';
import { Col } from 'react-bootstrap';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import GenericBlock from '../../../components/blocks/GenericBlock';
import IconBlock from '../../../components/blocks/IconBlock';
import YoutubeVideoImage from "../../../components/YoutubeVideoImage";

export default class Content extends React.Component {

    constructor(props) {
        super(props);

        this.title = 'Content';
    }

    render() {
        return (
            <BlockWrapper id="content">
                <IconBlock className="hidden-xs hidden-sm" icon="film">
                    <h3>{this.title}</h3>
                </IconBlock>

                <GenericBlock>
                    <Col md={6} sm={12} xs={12}>
                        <h4>{this.title}</h4>
                        <p>
                            Most organisations face difficulties to maintain presence in the hearts and minds of their target audiences. TROI brings a Netflix-like quality to storytelling which engages the audience and makes them come back for more.
                        </p>

                        <h4>What clients say</h4>
                        <p>
                            <i>"Strategy is the easy part of transformation. The real question is how to engage and commit the whole organisation to embrace change. TROI’s Opportunity & Challenge Video Format helps to build dialogue with employees around the good and the bad of our company."</i>
                        </p>
                        <p className="text-right"><i>Chief Transformation Officer</i></p>
                    </Col>

                    <Col md={6} sm={12} xs={12}>
                        <h4>Check out the video</h4>
                        <YoutubeVideoImage videoId="V5RL1DSzsMk" />
                    </Col>
                </GenericBlock>
            </BlockWrapper>
       );
    }

}



// WEBPACK FOOTER //
// ./src/pages/parts/companies/Content.js